<!-- Heading -->
<div #scrollable class="scroll-sidebar scroll-sidebar-auth opacity-block-double">
  <div class="container-fluid pb-6 my-7 my-lg-12">
    <div class="row-col-blocks row align-items-center justify-content-between">
      <div class="col-12 col-lg">
        <div class="text-center">
          <i-feather class="logo-big effect3d" name="vk" width="133" height="133"></i-feather>
        </div>
        <h1 class="font-bold text-center">Вконтакте</h1>
        <!-- Text -->
        <p class="text-center mb-6">Пожалуйста, введите свой полный номер телефона.</p>
        <!-- Form -->
        <alert [type]="'warning'" class="d-block"> Beta version </alert>
      </div>
      <div class="col-12 col-lg">
        <form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
          <div class="form-group">
            <label for="username" class="sr-only">Номер телефона</label>
            <input
              type="text"
              formControlName="username"
              class="form-control form-control-lg justify-content-between"
              placeholder="hello@vk.com"
              id="username"
            />
          </div>
          <div class="form-group">
            <label for="password" class="sr-only">Пароль</label>
            <input
              type="password"
              formControlName="password"
              class="form-control form-control-lg"
              placeholder="Введите ваш пароль"
              id="password"
            />
          </div>
          <!-- Submit -->
          <button
            (mousemove)="allService.effectMouseMove($event)"
            class="effectMouse effect-white btn btn-lg btn-block btn-primary d-flex align-items-center"
            type="submit"
          >
            Войти
            <i-feather [style.margin-top.px]="-5" name="log-in" class="ml-auto icon-md align-middle"></i-feather>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
